/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Add KeycloakUser Button
 */

import { ButtonProps, Button } from 'antd';
import { Link } from 'react-router-dom';
import { Plus } from '@icon-park/react';

import { getAddKeycloakUserPath } from 'utils/router';
import AccessControl from '../AccessControl';
/**
 * AddKeycloakUser
 * @param props
 */
const AddKeycloakUser: React.FC<ButtonProps> = (props) => {
	const newUserButton = (
		<Button type='primary' {...props} icon={<Plus />}>
			{'New User'}
		</Button>
	);

	return (
		<AccessControl permission='canAddUsers'>
			<Link key='add-user' to={getAddKeycloakUserPath()}>
				{newUserButton}
			</Link>
		</AccessControl>
	);
};

export default AddKeycloakUser;
